// extracted by mini-css-extract-plugin
export default {"card":"Ingredient_card__vbEKF","close":"Ingredient_close__dLEtb"};